<template>
  <div>
    <div class="modal fade" v-if="opt.show" :id="opt.id">
      <div class="modal-dialog modal-dialog-centered modal-success modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">{{opt.title}}</h4>
          </div>
          <div class="modal-body">
            <!-- <pre>{{summary}}</pre> -->
            <div role="tablist" class="custom-accordion" v-if="value > 0 && value == max">
              <b-card no-body class="mb-1" v-if="summary.success.length">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-btn
                    block
                    href="#"
                    v-b-toggle.accordion1
                    variant="success"
                    class="text-left"
                  >INFORMACIÓN</b-btn>
                </b-card-header>
                <b-collapse id="accordion1" accordion="my-accordion" role="tabpanel">
                  <b-card-body class="scroll-v-200">
                    <div class="card-text" v-for="(item, index) in summary.success" :key="index">
                      <span class="fa fa-check" />
                      {{ item }}
                    </div>
                  </b-card-body>
                </b-collapse>
              </b-card>
              <b-card no-body class="mb-1" v-if="summary.errors.length">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-btn
                    block
                    href="#"
                    v-b-toggle.accordion2
                    variant="danger"
                    class="text-left"
                  >ERRORES</b-btn>
                </b-card-header>
                <b-collapse id="accordion2" accordion="my-accordion" role="tabpanel">
                  <b-card-body class="scroll-v-200">
                    <div class="card-text" v-for="(item, index) in summary.errors" :key="index">
                      <span class="fa fa-close" />
                      {{ item }}
                    </div>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>

            <!-- <div v-if="value > 0 && value == max">
              <b-row>
                <b-col sm="12">
                  <b-alert show variant="success">
                    <b>INFORMACIÓN:</b>
                    <li
                      class="ml-2"
                      v-for="(error, index) in summary.success"
                      :key="index"
                    >{{ error }}</li>
                  </b-alert>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="12">
                  <b-alert show variant="warning">
                    <b>ERRORES:</b>
                    <li
                      class="ml-2"
                      v-for="(error, index) in summary.errors"
                      :key="index"
                    >{{ error }}</li>
                  </b-alert>
                </b-col>
              </b-row>
            </div>-->
            <upload-excel-component
              v-if="value == 0"
              :on-success="handleSuccess"
              :before-upload="beforeUpload"
            />
            <b-progress
              v-if="value > 0"
              :variant="'success'"
              :max="max"
              class="mb-3 mt-3"
              height="2rem"
              :animated="true"
            >
              <b-progress-bar
                class="font-weight-bold font-size-15"
                :value="value"
                :label="`${((value / max) * 100).toFixed(2)}%`"
              ></b-progress-bar>
            </b-progress>
          </div>

          <div class="modal-footer">
            <button
              v-if="tableData.length > 0 && value == 0"
              type="button"
              class="btn btn-success"
              @click="storeExcel()"
            >Importar</button>
            <button
              type="button"
              class="btn btn-danger"
              @click="closeModal()"
              :disabled="value != max"
            >Cerrar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UploadExcelComponent from "@/components/ImporterExcel.vue";
import moment from "moment";
export default {
  name: "uploadData",
  props: ["options"],
  components: { UploadExcelComponent },
  data: () => {
    return {
      token: localStorage.getItem("token"),
      isAdmin: localStorage.getItem("auth_is_admin") === "S" ? true : false,
      opt: {},
      tableData: [],
      tableHeader: [],
      summary: { errors: [], success: [] },
      errores: [],
      max: 0,
      value: 0,
      rowCount: -1
    };
  },
  created() {
    if (
      this.options != undefined &&
      this.options != null &&
      this.options.show
    ) {
      this.opt = this.options;
      setTimeout(() => {
        hideLoader();
        this.openModal();
      }, 100);
    }
  },

  methods: {
    openModal() {
      $("#" + this.opt.id).modal({ backdrop: "static", keyboard: false }); // EVITA QUE SE CIERRE EL MODAL AL DAR CLIC FUERA DE EL
      $("#" + this.opt.id).modal("show");
    },
    beforeUpload(file) {
      this.tableData = [];
      this.tableHeader = [];
      this.mostrarResumen = false;

      const isLt1M = file.size / 1024 / 1024 < 1;
      if (isLt1M) {
        return true;
      } else {
        this.$swal({
          title: "Advertencia",
          text: "Por favor, no cargue archivos de más de 1M de tamaño.",
          type: "warning",
          showCancelButton: false,
          confirmButtonText: "Aceptar"
        }).then(result => {
          return false;
        });

        return false;
      }
    },
    handleSuccess({ results, header }) {
      this.tableData = results;
      this.tableHeader = header;
      this.tableData.splice(0, 2); // SE QUITA LAS DOS FILAS QUE NO TIENEN DATOS, SOLO SON ENCABEZADOS
      //console.log(this.tableData)
      this.mostrarResumen = true;
      this.$swal({
        title: "Buen trabajo",
        text: "Items leidos correctamente!",
        type: "success",
        showCancelButton: false,
        confirmButtonText: "Aceptar"
      }).then(result => {});
    },
    storeExcel() {
      showLoader();

      this.rowCount = 0;
      this.errores = [];
      this.max = this.tableData.length;
      let auth = localStorage.getItem("auth");
      auth = JSON.parse(auth);

      for (var i = 0; i < this.tableData.length; i++) {
        var item = this.tableData[i];
        item.type_store = this.opt.type_store;
        item.user_id = auth[0].id;
        let datos = JSON.stringify(item);
        this.$http
          .post(`${this.$urlApi}${this.opt.url}?token=${this.token}`, datos, {
            headers: { "Content-Type": "application/json" }
          })
          .then(function(response) {
            // console.log(response);
            hideLoader();
            if (response.data.success == false) {
              this.summary.errors.push(response.data.message);
            } else {
              this.summary.success.push(response.data.message);
            }
            this.value += 1;
          })
          .catch(error => {
            this.value += 1;
            hideLoader();
            console.log(error);
            this.summary.errors.push(error.body.message);
          });
      }
    },

    closeModal() {
      $("#" + this.opt.id).modal("hide");
      console.log(this.opt);
      this.tableData = [];
      this.tableHeader = [];
      this.errores = [];
      this.rowCount = -1;
      this.opt = { show: false };
      location.reload();
    }
  }
};
</script>
